import { Node, Mark, MarkType } from "prosemirror-model";

/**
 * Returns the from and to for a given mark on a given position.
 */
export function expandMark(doc: Node, pos: number, mark: Mark | MarkType) {
    // Search backwards and forwards to find mark boundaries
    const $pos = doc.resolve(pos);

    // Search backwards
    let nodeStart = $pos.start();
    let from = pos;
    while (from > nodeStart) {
        const found = doc.rangeHasMark(from - 1, from, mark);
        if (!found) break;
        from--;
    }

    // Search forwards
    let nodeEnd = $pos.end();
    let to = pos;
    while (to < nodeEnd) {
        const found = doc.rangeHasMark(to, to + 1, mark);
        if (!found) break;
        to++;
    }

    return { from, to };
}

/**
 * Returns the from and to for a given word on a given position.
 */
export function expandWord(doc: Node, pos: number, breakOn: RegExp = /\w/) {
    const $pos = doc.resolve(pos);
    const text = $pos.parent.textContent;
    const posInNode = $pos.parentOffset;

    // Search backwards
    let from = posInNode;
    while (from > 0) {
        const char = text.charAt(from - 1);
        if (!breakOn.test(char)) break;
        from--;
    }

    // Search forwards
    let to = posInNode;
    while (to < text.length) {
        const char = text.charAt(to);
        if (!breakOn.test(char)) break;
        to++;
    }

    // Convert positions relative to node into absolute document positions
    return { from: $pos.start() + from, to: $pos.start() + to };
}
